import { useMutation, useQuery } from "@tanstack/react-query";
import { getPhysicalCountEnquiry } from "services/data.report.service";
import { TableCard } from "ui-components/Layout";
import { ListLayout } from "ui-components/Layout";
import BasicTable from "ui-components/tables/BasicTable";
import { PhysicalCountColumns } from "./columns";
import { useState } from "react";
import { useCustomerValue } from "providers/CustomerContext";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { CSVLink } from "react-csv";
import { Texts } from "ui-components/Form";
import { Grid } from "@mui/material";
import { CustomDateRangePicker } from "ui-components/CustomInput";
import dayjs from "dayjs";
import { Error_ } from "ui-components/Alert";
import { LoadingDialog } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";
import { ExportDialog } from "ui-components/Alert";

function PhysicalCountEnquiry() {
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const [data, setData] = useState([]);
  const date = dayjs(new Date()).format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(date);
  const [endDate, setEndDate] = useState(date);
  const [filteredData, setFilteredData] = useState([]);
  const { downloadCsv, isDownloading } = useCsvDownloadHook();
  const handleFilterRowsChange = (filteredData) => { setFilteredData(filteredData); };
  const { refetch, isFetching } = useQuery({
    queryKey: ["sku-movement-enquiry", { customerCode }],
    queryFn: () => getPhysicalCountEnquiry({ customerCode, startDate, endDate }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => { setData(data.data.data); setFilteredData(data.data.data); },
    onError: () => { },
  });
  const { permissions, allowAll } = useTeamValue()
  const exportPermission = allowAll || (Boolean(permissions["Physical Count_Report"]) && permissions["Physical Count_Report"].findIndex(b => b === "export") !== -1);

  const customProps = { startDate, setStartDate, endDate, setEndDate };

  const onFetch = () => {
    setAlert(null);
    const valid =
      dayjs(endDate).isSame(dayjs(startDate)) || dayjs(endDate).isAfter(dayjs(startDate));
    if (!valid) {
      setAlert(<Error_ content="Start date cannot greater than end date" onChange={setAlert} />);
      return;
    }
    if (dayjs(date).isBefore(endDate)) {
      setAlert(<Error_ content="End date cannot greater than today date" onChange={setAlert} />);
      return;
    }
    refetch();
  };

  return (
    <ListLayout>
      {isFetching && <LoadingDialog />}
      {isDownloading && <ExportDialog />}
      {alert && <MDBox sx={{ my: 3 }}>{alert}</MDBox>}

      <TableCard sx={{ my: 3 }}>
        <MDBox margin="1rem 0 0 1rem">
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <CustomDateRangePicker {...customProps} />
            </Grid>
            <Grid item xs={4}>
              <MDButton
                variant="gradient"
                color="info"
                onClick={() => {
                  onFetch();
                }}
              >
                search
              </MDButton>
              {/* <MDButton sx={{ marginLeft: "1rem" }} variant="gradient" color="info" disabled={!exportPermission}>
                <CSVLink style={{ color: "white" }} filename={`Physical-Count`} data={filteredData}>
                  export
                </CSVLink>
              </MDButton> */}
              <MDButton
                sx={{ marginLeft: "1rem" }} variant="gradient" color="info" disabled={!exportPermission}
                onClick={() => {
                  const filename = `${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_PhysicalCount`;
                  downloadCsv(filename, filteredData)
                }}
              >
                export
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>

        <BasicTable data={data} columns={PhysicalCountColumns} onFilterRowsChange={handleFilterRowsChange} />
      </TableCard>
    </ListLayout>
  );
}

export default PhysicalCountEnquiry;
